/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import { Input} from "antd";
import { createFromIconfontCN } from '@ant-design/icons';
import { UserOutlined, KeyOutlined } from '@ant-design/icons';




const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_8d5l8fzk5b87iudi.js',
});



class Inputlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      feildData: {},
      vital_val:true,
    };
  }
  componentDidMount() {
    let { feildData } = this.props;
    if(feildData.name==="vitals_required"){
      this.state.vital_val=!feildData.value;
    }
    this.setState((state) => ({ feildData: feildData }));
  }

  componentDidUpdate(prevProps, pervState) {
    if (prevProps.feildData.value != this.props.feildData.value) {
      let { feildData } = this.props;
      this.setState((state) => ({ feildData: feildData }));
    }
  }

  handleKeyPress = ($event) => {
    
    let { feildData } = this.state;

    if(feildData.name==="vitals_required"){
      this.setState({ vital_val: !this.state.vital_val });
   
      feildData["value"] =this.state.vital_val;
    }
    else{
    feildData["value"] = $event.target.value;
    this.setState((state) => ({ feildData: feildData }));}
    if ($event.charCode == 13) {
      this.props.onInputChanges({
        enter: true,
        name: $event.target.name,
        text: $event.target.value,
        value: $event.target.value,
        type: "enter",
      });
    }
  };
  onChange($event) {
    this.props.onInputChanges({
      enter: false,
      name: $event.target.name,
      text: $event.target.value,
      value: $event.target.value,
      type: "blur",
    });
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }
  render() {
    let feildData = this.state.feildData;
    if (feildData.name === "approched_time") {
      feildData.value = this.formatAMPM(new Date());
    }
    // if (feildData.name === "vitals-need") {
    //   feildData.value = this.state.vital_val;
    // }
    return (
      <div className="form-group mb-0">
        {Object.keys(feildData).length !== 0 && (
          <React.Fragment>
            {/* <span className="ant-input-affix-wrapper">
                        <span className="ant-input-prefix"><Icon type = {feildData.icon} style = {{ color: 'rgba(0,0,0,.25)' }}/></span>
                        <input  value={feildData.value ? feildData.value:''}  type={feildData.input_type}  name={feildData.name}  onChange={(e)=> this.handleKeyPress(e)} onKeyPress={(e)=> this.handleKeyPress(e)}
                                            onBlur={this.onChange.bind(this)}
                                            disabled={feildData.disable?feildData.disable:false}
                                            placeholder={feildData.placeholder} className="ant-input" />
                    </span> */}
       
  {/* <Input

    value={feildData.value}
    checked={feildData.value}
    type={feildData.input_type}
    name={feildData.name}
    onChange={(e) => this.handleKeyPress(e)}
    onKeyPress={(e) => this.handleKeyPress(e)}
    onBlur={this.onChange.bind(this)}
    disabled={feildData.disable ? feildData.disable : false}
    placeholder={feildData.placeholder}
    prefix={
      <IconFont type={feildData.icon} style={{ color: 'rgba(0,0,0,.25)' }} />
    }
  /> */}
  {this.props.login && this.props.login=="login field"?(
 <Input
//  autoComplete="off" 
className="custom-input"
  value={feildData.value}
  checked={feildData.value}
  type={feildData.input_type}
  name={feildData.name}
  onChange={(e) => this.handleKeyPress(e)}
  onKeyPress={(e) => this.handleKeyPress(e)}
  onBlur={this.onChange.bind(this)}
  
  // prefix={<UserOutlined style={{ marginRight: 8 }} />}
  prefix={feildData.icon=="user"?<UserOutlined style={{ marginRight: 8 ,marginLeft: 8, color: 'white'}} />:(feildData.icon=="key"?<KeyOutlined style={{ marginRight: 8 ,marginLeft: 8, color: 'white'}}/>:<IconFont type={feildData.icon} />)}
  disabled={feildData.disable ? feildData.disable : false}
 placeholder={ feildData.placeholder}
 
 
 style={{backgroundColor:  "lightgray",color:"white" ,borderRadius:" 5px",border:"solid 1px #66b1d0" }}
  
/>):(
 <Input
//  autoComplete="off" 
  value={feildData.value}
  checked={feildData.value}
  type={feildData.input_type}
  name={feildData.name}
  onChange={(e) => this.handleKeyPress(e)}
  onKeyPress={(e) => this.handleKeyPress(e)}
  onBlur={this.onChange.bind(this)}
  
  // prefix={<UserOutlined style={{ marginRight: 8 }} />}
  prefix={feildData.icon=="user"?<UserOutlined style={{ marginRight: 8 ,marginLeft: 8, color: 'lightgray'}} />:(feildData.icon=="key"?<KeyOutlined style={{ marginRight: 8 ,marginLeft: 8, color: 'lightgray'}}/>:<IconFont type={feildData.icon} />)}
  disabled={feildData.disable ? feildData.disable : false}
 placeholder={ feildData.placeholder}
 
 style={{width: feildData.name==='vitals_required'? "30px":"",border:feildData.name==='vitals_required'?"0px":"",border:feildData.name==='vitals_required'?"0px":"",}}

/>)}
{/* style={{ color: 'rgba(0,0,0,.25)', height:"30px", padding:"0px", width:"300px", margin:"0px",border:"none",marginLeft:"0px",align:"center" ,outline:"none"}} */}
{/* prefix={<IconFont type={feildData.icon} />} */}

            {feildData.name === "service_time" && (
              <small>Enter in Minutes</small>
            )}
            {feildData.errors.map((error, eKey) => {
              return (
                <small key={eKey} className="form-text text-danger">
                  {error.message}
                </small>
              );
            })}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default Inputlayer;
